module.exports = __webpack_public_path__ + "img/GHS07.6a443fc2.webp";